import { Route } from 'vue-router';
import axios, {
  AxiosInstance,
  AxiosResponse,
  AxiosRequestConfig,
  AxiosError,
  CancelTokenSource,
} from 'axios';
// import store from '@/store';
import { CoreModule } from '@/store/modules/core';
import { wechatAuth } from '@/main';
import { Toast, Dialog } from 'vant';
import router from '@/router';
import Log from '@/components/log';
import { env } from '@/env';
export interface WeAxiosRequestConfig extends AxiosRequestConfig {
  weRegister?: boolean;
  weLoading?: boolean;
  weBindUser?: boolean;
  weSilentReg?: boolean;
  weSilentAuth?: boolean;
  weSilentBind?: boolean;
}

const defaultConfig = {
  weRegister: false,
  weLoading: false,
  weBindUser: false,
  weSilentReg: false,
  weSilentAuth: true,
  weSilentBind: false,
};
const CancelToken = axios.CancelToken;
const source: CancelTokenSource = CancelToken.source();

const requestInterceptorOK = (originalConfig: WeAxiosRequestConfig) => {
  const config: WeAxiosRequestConfig = Object.assign(
    {},
    defaultConfig,
    originalConfig
  );
  if (config.method !== 'OPTIONS' && config.weLoading) {
    Toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true, // 禁用背景点击
      message: '加载中..',
    });
  }

  const route: Route = router.currentRoute;
  if (!wechatAuth.isAuthed()) {
    if (config.weSilentAuth) {
      Dialog.confirm({
        title: '注意',
        message: wechatAuth.wechatConfig.autoAuthMsg,
      })
        .then(() => {
          gotoAuthPage();
        })
        .catch(() => {
          // on cancel
        });
    } else {
      gotoAuthPage();
    }
    config.cancelToken = source.token;
    source.cancel('no auth');
  }

  if (config.weBindUser && !wechatAuth.isBindUser()) {
    if (!config.weSilentBind) {
      Dialog.confirm({
        title: '注意',
        message: wechatAuth.wechatConfig.bindUserMsg,
      })
        .then(() => {
          gotoBindUserPage();
        })
        .catch(() => {
          // on cancel
        });
    } else {
      gotoBindUserPage();
    }
    config.cancelToken = source.token;
    source.cancel('no auth');
  }

  if (config.weRegister && !wechatAuth.isRegister()) {
    if (!config.weSilentReg) {
      Dialog.confirm({
        title: '注意',
        message: wechatAuth.wechatConfig.registerMsg,
      })
        .then(() => {
          gotoRegisterPage();
        })
        .catch(() => {
          // on cancel
        });
    } else {
      gotoRegisterPage();
    }
    config.cancelToken = source.token;
    source.cancel('no register');
  }
  if (env.VUE_APP_WX_ACCESS_ID === 'ws2') {
    config.headers.Authorization = CoreModule.auth.authorization;
  } else {
    // config.headers.Authorization = (store.state as any).core.auth.authorization;
    config.headers.Authorization = CoreModule.auth.authorization;
  }
  return config;
};
const requestInterceptorErr = (error: Error) => {
  // 请求错误处理
  Toast({
    position: 'bottom',
    message: '请求错误:' + error.message,
  });
  Log.error(error);
  Promise.reject(error);
};

const responseInterceptorOK = (response: AxiosResponse) => {
  const config: WeAxiosRequestConfig = response.config as WeAxiosRequestConfig;
  if (config.method !== 'OPTIONS' && config.weLoading) {
    Toast.clear();
  }
  return response;
};
const responseInterceptorErr = (error: AxiosError) => {
  const config: WeAxiosRequestConfig = error.config;
  let toastMsg = null;
  Toast.clear();
  if (error.response) {
    const status = error.response.status;
    switch (status) {
      case 401:
      // do nothing
      case 406:
        toastMsg = '登录信息失效';
        if (config.weSilentAuth) {
          Dialog.confirm({
            title: '注意',
            message: wechatAuth.wechatConfig.autoAuthMsg,
          })
            .then(() => {
              gotoAuthPage();
            })
            .catch(() => {
              // on cancel
            });
        } else {
          gotoAuthPage();
        }
        // break;
        return;
      case 500:
        // toastMsg = "服务器内部错";
        // if (error.response.data) {
        //   const rdata = error.response.data;
        //   toastMsg = toastMsg + ":" + (rdata.errid ? rdata.errid : "");
        // }
        router.replace('/main/error/dxpqError/FZZ');
        break;
      case 404:
        router.replace('/main/error/dxpqError/FZF');
        break;
      case 502:
        router.replace('/main/error/dxpqError/FZT');
        break;
      case 403:
        toastMsg = '没有权限';
        break;
      default:
        toastMsg = '未知错误:' + status;
    }
  } else {
    if (error.message === 'Network Error') {
      toastMsg = '网络异常';
    } else if (
      error.code === 'ECONNABORTED' &&
      error.message.indexOf('timeout') !== -1
    ) {
      toastMsg = '网络连接超时';
    }
  }
  if (toastMsg) {
    Toast({
      position: 'bottom',
      message: toastMsg,
    });
  }
  Log.info(error);
  return Promise.reject(error);
};

function gotoAuthPage() {
  const route: Route = router.currentRoute;
  CoreModule.clearAuth();
  if ((route.meta as any).auth) {
    // router.replace(route);
    router.go(0);
  } else {
    router.replace(wechatAuth.wechatConfig.autoAuthPage as string);
  }
}

function gotoRegisterPage() {
  router.push(wechatAuth.wechatConfig.registerPage as string);
}

function gotoBindUserPage() {
  router.push(wechatAuth.wechatConfig.bindUserPage as string);
}

const api: AxiosInstance = axios.create({
  baseURL: env.VUE_APP_URL, // api的base_url
  timeout: 60000, // 请求超时时间
});

api.interceptors.request.use(requestInterceptorOK, requestInterceptorErr);

api.interceptors.response.use(responseInterceptorOK, responseInterceptorErr);

export default api;

export const apibase: AxiosInstance = axios.create({
  baseURL: env.VUE_APP_URL, // api的base_url
  timeout: 60000, // 请求超时时间
});

apibase.interceptors.response.use(
  (response: AxiosResponse) => response,
  responseInterceptorErr
);

export const apidynamic: AxiosInstance = axios.create({
  baseURL: env.VUE_APP_URL, // api的base_url
  timeout: 60000, // 请求超时时间
});

const requestInterceptorDynamic = (originalConfig: WeAxiosRequestConfig) => {
  if (CoreModule.auth) {
    // originalConfig.headers.Authorization = CoreModule.auth.authorization;
    if (env.vue_app_wx_access_id === 'ws2') {
      originalConfig.headers.Authorization = CoreModule.auth.authorization;
    } else {
      // config.headers.Authorization = (store.state as any).core.auth.authorization;
      originalConfig.headers.Authorization = CoreModule.auth.authorization;
    }
  }
  return originalConfig;
};
apidynamic.interceptors.request.use(requestInterceptorDynamic);
apidynamic.interceptors.response.use(
  (response: AxiosResponse) => response,
  responseInterceptorErr
);
